export default {
	notification_health: 'Stav upozornení',
	notification_health_summary: 'Súhrn',
	notification_health_loading: 'Kontrola stavu upozornení...',
	notification_health_refresh: 'Obnoviť',
	notification_health_fix: 'Čo robiť',
	notification_health_unavailable: 'Nepodarilo sa načítať stav upozornení',
	notification_health_healthy: 'V poriadku',
	notification_health_blocked: 'Blokované',
	notification_health_degraded: 'Vyžaduje pozornosť',
	notification_health_no_app_user: 'Bez prihlásenia do aplikácie',
	notification_health_unknown: 'Neznáme',
	notification_health_app_version: 'Verzia aplikácie',
	notification_health_last_delivery: 'Posledné doručenie',
	notification_health_time_just_now: 'práve teraz',
	notification_health_time_minutes: 'pred {count} min.',
	notification_health_time_hours: 'pred {count} hod.',
	notification_health_time_days: 'pred {count} dňami',
	notification_health_time_unknown: 'neznáme',
	notification_health_summary_healthy: 'Upozornenia by mali fungovať',
	notification_health_summary_no_app_user: 'Upratovač sa neprihlásil do mobilnej aplikácie',
	notification_health_summary_blocked_no_token: 'Chýba push token — upratovač musí otvoriť aplikáciu a prihlásiť sa',
	notification_health_summary_blocked_off: 'Upozornenia sú v aplikácii vypnuté',
	notification_health_check_portal_contact_label: 'Kontakt v portáli existuje',
	notification_health_check_portal_active_label: 'Kontakt je aktívny',
	notification_health_check_portal_rooms_label: 'Priradené miestnosti',
	notification_health_check_portal_shifts_label: 'Priradené smeny',
	notification_health_check_app_user_label: 'Prihlásený do mobilnej aplikácie',
	notification_health_check_push_token_label: 'Push token registrovaný',
	notification_health_check_notification_mode_label: 'Režim upozornení',
	notification_health_check_time_schedule_label: 'V rámci časového okna upozornení',
	notification_health_check_ios_geo_filter_label: 'Filter polohy iOS',
	notification_health_check_recent_push_attempt_label: 'Nedávny pokus o push (48 h)',
	notification_health_check_last_push_ignored_label: 'Posledný signál nebol odoslaný',
	notification_health_check_recent_push_delivered_label: 'Nedávne doručenie push (48 h)',
	notification_health_detail_portal_contact_found: 'Nájdené v portáli',
	notification_health_detail_portal_contact_missing: 'Záznam kontaktu sa nenašiel',
	notification_health_detail_portal_active_active: 'Aktívny',
	notification_health_detail_portal_active_inactive: 'Neaktívny',
	notification_health_detail_portal_rooms_assigned: '{count} miestností',
	notification_health_detail_portal_rooms_none: 'Žiadne miestnosti nepriradené',
	notification_health_detail_portal_shifts_assigned: '{count} smien',
	notification_health_detail_portal_shifts_none: 'Žiadne smeny nepriradené',
	notification_health_detail_app_user_logged_in: 'Verzia aplikácie {version}, posledná synchronizácia {lastSync}',
	notification_health_detail_app_user_never: 'Nikdy sa neprihlásil',
	notification_health_detail_push_token_present: 'FCM token prítomný',
	notification_health_detail_push_token_empty: 'Token je prázdny',
	notification_health_detail_notification_mode: '{mode}',
	notification_health_detail_time_schedule_inside: 'Aktuálny čas je v rámci rozvrhu',
	notification_health_detail_time_schedule_outside: 'Aktuálny čas je mimo nastaveného rozvrhu',
	notification_health_detail_ios_geo_filter: '{filter}',
	notification_health_detail_recent_push_attempt_at: '{time}',
	notification_health_detail_recent_push_attempt_none: 'Žiadne pokusy o push za posledných 48 hodín',
	notification_health_detail_last_push_ignored: 'Posledná požiadavka push bola ignorovaná (servik nie je nakonfigurovaný pre pracovnú oblasť)',
	notification_health_detail_recent_push_delivered_at: '{time}',
	notification_health_detail_recent_push_delivered_none: 'Žiadne úspešné doručenia za posledných 48 hodín',
	notification_health_fix_portal_contact: 'Vytvorte tohto upratovača v paneli Používatelia',
	notification_health_fix_portal_active: 'Zapnite prepínač Aktívny pre tohto upratovača',
	notification_health_fix_portal_rooms: 'Priraďte aspoň jednu miestnosť tomuto upratovačovi',
	notification_health_fix_portal_shifts: 'Priraďte aspoň jednu smenu',
	notification_health_fix_app_user: 'Upratovač musí nainštalovať aplikáciu a prihlásiť sa týmto telefónnym číslom',
	notification_health_fix_push_token: 'Požiadajte upratovača, aby otvoril aplikáciu, povolil upozornenia v nastaveniach iOS a znova sa prihlásil',
	notification_health_fix_notification_mode: 'Zmeňte režim upozornení z Vypnuté na Vždy v aplikácii',
	notification_health_fix_time_schedule: 'Počkajte do naplánovaného okna alebo zmeňte režim na Vždy',
	notification_health_fix_ios_geo_filter: 'Upratovač je mimo zóny upozornení — požiadajte ho, aby otvoril aplikáciu na mieste',
	notification_health_fix_last_push_ignored: 'Skontrolujte konfiguráciu servik pracovnej oblasti pre miestnosť, ktorá spustila signál',
	notification_health_fix_recent_push_delivered_filters: 'Skontrolujte filtre upozornení alebo nastavenia zariadenia',
	notification_health_fix_recent_push_delivered_token: 'Najprv zaregistrujte push token',
	notification_health_mode_on: 'Vždy',
	notification_health_mode_off: 'Vypnuté',
	notification_health_mode_time: 'Podľa času',
	notification_health_mode_location: 'Podľa polohy',
	notification_health_filter_on: 'Zapnuté',
	notification_health_filter_off: 'Vypnuté',
};
